// Customer service definitions for the public-facing frontends.
// Used by: customer_area (B2B order form), mini_shop (prospect shop),
// contact_form, and care_ai (skin analysis).

// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file customer/customer.proto (package mw.customer, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { Address, Customer, MiniShop, Order, OrderFormV2Category, OrderFormV2CategoryGrouped, OrderSummary, Product, SkinProblem, UsageType } from "../common/common_pb.js";

/**
 * @generated from message mw.customer.AuthenticateRequest
 */
export class AuthenticateRequest extends Message<AuthenticateRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  /**
   * If set, email and password are ignored; the token is refreshed instead.
   *
   * @generated from field: string auth_token = 3;
   */
  authToken = "";

  /**
   * JSON-encoded user agent data for analytics.
   *
   * @generated from field: string user_agent = 4;
   */
  userAgent = "";

  constructor(data?: PartialMessage<AuthenticateRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AuthenticateRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuthenticateRequest {
    return new AuthenticateRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AuthenticateRequest | PlainMessage<AuthenticateRequest> | undefined, b: AuthenticateRequest | PlainMessage<AuthenticateRequest> | undefined): boolean {
    return proto3.util.equals(AuthenticateRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.AuthenticateResponse
 */
export class AuthenticateResponse extends Message<AuthenticateResponse> {
  /**
   * Session token for subsequent authenticated requests.
   *
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * Full customer profile.
   *
   * @generated from field: mw.common.Customer customer = 2;
   */
  customer?: Customer;

  constructor(data?: PartialMessage<AuthenticateResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AuthenticateResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "customer", kind: "message", T: Customer },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AuthenticateResponse {
    return new AuthenticateResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AuthenticateResponse | PlainMessage<AuthenticateResponse> | undefined, b: AuthenticateResponse | PlainMessage<AuthenticateResponse> | undefined): boolean {
    return proto3.util.equals(AuthenticateResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.RequestNewPasswordTokenRequest
 */
export class RequestNewPasswordTokenRequest extends Message<RequestNewPasswordTokenRequest> {
  /**
   * @generated from field: string email_address = 1;
   */
  emailAddress = "";

  constructor(data?: PartialMessage<RequestNewPasswordTokenRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.RequestNewPasswordTokenRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestNewPasswordTokenRequest {
    return new RequestNewPasswordTokenRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestNewPasswordTokenRequest {
    return new RequestNewPasswordTokenRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestNewPasswordTokenRequest {
    return new RequestNewPasswordTokenRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RequestNewPasswordTokenRequest | PlainMessage<RequestNewPasswordTokenRequest> | undefined, b: RequestNewPasswordTokenRequest | PlainMessage<RequestNewPasswordTokenRequest> | undefined): boolean {
    return proto3.util.equals(RequestNewPasswordTokenRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.RequestNewPasswordTokenResponse
 */
export class RequestNewPasswordTokenResponse extends Message<RequestNewPasswordTokenResponse> {
  /**
   * Always true (to prevent email enumeration).
   *
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<RequestNewPasswordTokenResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.RequestNewPasswordTokenResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RequestNewPasswordTokenResponse {
    return new RequestNewPasswordTokenResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RequestNewPasswordTokenResponse {
    return new RequestNewPasswordTokenResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RequestNewPasswordTokenResponse {
    return new RequestNewPasswordTokenResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RequestNewPasswordTokenResponse | PlainMessage<RequestNewPasswordTokenResponse> | undefined, b: RequestNewPasswordTokenResponse | PlainMessage<RequestNewPasswordTokenResponse> | undefined): boolean {
    return proto3.util.equals(RequestNewPasswordTokenResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.SaveNewPasswordRequest
 */
export class SaveNewPasswordRequest extends Message<SaveNewPasswordRequest> {
  /**
   * Reset token from the password reset email.
   *
   * @generated from field: string new_password_token = 1;
   */
  newPasswordToken = "";

  /**
   * Active session token (if set, new_password_token is ignored).
   *
   * @generated from field: string auth_token = 2;
   */
  authToken = "";

  /**
   * @generated from field: string new_password = 3;
   */
  newPassword = "";

  constructor(data?: PartialMessage<SaveNewPasswordRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SaveNewPasswordRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "new_password_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "new_password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaveNewPasswordRequest {
    return new SaveNewPasswordRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaveNewPasswordRequest {
    return new SaveNewPasswordRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaveNewPasswordRequest {
    return new SaveNewPasswordRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SaveNewPasswordRequest | PlainMessage<SaveNewPasswordRequest> | undefined, b: SaveNewPasswordRequest | PlainMessage<SaveNewPasswordRequest> | undefined): boolean {
    return proto3.util.equals(SaveNewPasswordRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.SaveNewPasswordResponse
 */
export class SaveNewPasswordResponse extends Message<SaveNewPasswordResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * New auth token (old one is invalidated).
   *
   * @generated from field: string auth_token = 2;
   */
  authToken = "";

  constructor(data?: PartialMessage<SaveNewPasswordResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SaveNewPasswordResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SaveNewPasswordResponse {
    return new SaveNewPasswordResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SaveNewPasswordResponse {
    return new SaveNewPasswordResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SaveNewPasswordResponse {
    return new SaveNewPasswordResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SaveNewPasswordResponse | PlainMessage<SaveNewPasswordResponse> | undefined, b: SaveNewPasswordResponse | PlainMessage<SaveNewPasswordResponse> | undefined): boolean {
    return proto3.util.equals(SaveNewPasswordResponse, a, b);
  }
}

/**
 * ContactFormValue is a key-value pair for a single form field.
 *
 * @generated from message mw.customer.ContactFormValue
 */
export class ContactFormValue extends Message<ContactFormValue> {
  /**
   * @generated from field: string key = 1;
   */
  key = "";

  /**
   * @generated from field: string value = 2;
   */
  value = "";

  constructor(data?: PartialMessage<ContactFormValue>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ContactFormValue";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ContactFormValue {
    return new ContactFormValue().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ContactFormValue {
    return new ContactFormValue().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ContactFormValue {
    return new ContactFormValue().fromJsonString(jsonString, options);
  }

  static equals(a: ContactFormValue | PlainMessage<ContactFormValue> | undefined, b: ContactFormValue | PlainMessage<ContactFormValue> | undefined): boolean {
    return proto3.util.equals(ContactFormValue, a, b);
  }
}

/**
 * @generated from message mw.customer.SubmitContactFormRequest
 */
export class SubmitContactFormRequest extends Message<SubmitContactFormRequest> {
  /**
   * Form field values (dynamic, defined by the frontend form variant).
   *
   * @generated from field: repeated mw.customer.ContactFormValue contact_form_values = 2;
   */
  contactFormValues: ContactFormValue[] = [];

  /**
   * Form variant. Empty = default B2C contact form. Recognized values:
   * becomePartner, Device, PLCC, Incentive. Unknown values fall to default.
   *
   * @generated from field: string form_type = 3;
   */
  formType = "";

  constructor(data?: PartialMessage<SubmitContactFormRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SubmitContactFormRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 2, name: "contact_form_values", kind: "message", T: ContactFormValue, repeated: true },
    { no: 3, name: "form_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitContactFormRequest {
    return new SubmitContactFormRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitContactFormRequest {
    return new SubmitContactFormRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitContactFormRequest {
    return new SubmitContactFormRequest().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitContactFormRequest | PlainMessage<SubmitContactFormRequest> | undefined, b: SubmitContactFormRequest | PlainMessage<SubmitContactFormRequest> | undefined): boolean {
    return proto3.util.equals(SubmitContactFormRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.SubmitContactFormResponse
 */
export class SubmitContactFormResponse extends Message<SubmitContactFormResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  constructor(data?: PartialMessage<SubmitContactFormResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SubmitContactFormResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SubmitContactFormResponse {
    return new SubmitContactFormResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SubmitContactFormResponse {
    return new SubmitContactFormResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SubmitContactFormResponse {
    return new SubmitContactFormResponse().fromJsonString(jsonString, options);
  }

  static equals(a: SubmitContactFormResponse | PlainMessage<SubmitContactFormResponse> | undefined, b: SubmitContactFormResponse | PlainMessage<SubmitContactFormResponse> | undefined): boolean {
    return proto3.util.equals(SubmitContactFormResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrdersRequest
 */
export class GetOrdersRequest extends Message<GetOrdersRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  constructor(data?: PartialMessage<GetOrdersRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrdersRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrdersRequest {
    return new GetOrdersRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrdersRequest {
    return new GetOrdersRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrdersRequest {
    return new GetOrdersRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrdersRequest | PlainMessage<GetOrdersRequest> | undefined, b: GetOrdersRequest | PlainMessage<GetOrdersRequest> | undefined): boolean {
    return proto3.util.equals(GetOrdersRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrdersResponse
 */
export class GetOrdersResponse extends Message<GetOrdersResponse> {
  /**
   * @generated from field: repeated mw.common.Order orders = 1;
   */
  orders: Order[] = [];

  constructor(data?: PartialMessage<GetOrdersResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrdersResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrdersResponse {
    return new GetOrdersResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrdersResponse {
    return new GetOrdersResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrdersResponse {
    return new GetOrdersResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrdersResponse | PlainMessage<GetOrdersResponse> | undefined, b: GetOrdersResponse | PlainMessage<GetOrdersResponse> | undefined): boolean {
    return proto3.util.equals(GetOrdersResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.CreateOrderRequest
 */
export class CreateOrderRequest extends Message<CreateOrderRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * Customer note / special instructions.
   *
   * @generated from field: string note = 2;
   */
  note = "";

  /**
   * Map of product GUID -> quantity (as string).
   *
   * @generated from field: map<string, string> product_quantities = 3;
   */
  productQuantities: { [key: string]: string } = {};

  /**
   * Optional separate delivery address.
   *
   * @generated from field: mw.common.Address delivery_address = 4;
   */
  deliveryAddress?: Address;

  constructor(data?: PartialMessage<CreateOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CreateOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "note", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "delivery_address", kind: "message", T: Address },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrderRequest {
    return new CreateOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrderRequest {
    return new CreateOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrderRequest {
    return new CreateOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrderRequest | PlainMessage<CreateOrderRequest> | undefined, b: CreateOrderRequest | PlainMessage<CreateOrderRequest> | undefined): boolean {
    return proto3.util.equals(CreateOrderRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.CreateOrderResponse
 */
export class CreateOrderResponse extends Message<CreateOrderResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: mw.common.Order order = 2;
   */
  order?: Order;

  /**
   * Items that were in the cart but excluded from the created order because
   * they were no longer orderable at submit time (typically out of stock).
   * The frontend uses this to show a "diese Artikel waren nicht verfügbar"
   * notice on the success page.
   *
   * @generated from field: repeated mw.customer.SkippedOrderItem skipped_items = 3;
   */
  skippedItems: SkippedOrderItem[] = [];

  constructor(data?: PartialMessage<CreateOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CreateOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "order", kind: "message", T: Order },
    { no: 3, name: "skipped_items", kind: "message", T: SkippedOrderItem, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateOrderResponse {
    return new CreateOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateOrderResponse {
    return new CreateOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateOrderResponse {
    return new CreateOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateOrderResponse | PlainMessage<CreateOrderResponse> | undefined, b: CreateOrderResponse | PlainMessage<CreateOrderResponse> | undefined): boolean {
    return proto3.util.equals(CreateOrderResponse, a, b);
  }
}

/**
 * SkippedOrderItem describes a single cart entry that was not transmitted on
 * submit and the reason why.
 *
 * @generated from message mw.customer.SkippedOrderItem
 */
export class SkippedOrderItem extends Message<SkippedOrderItem> {
  /**
   * GUID of the affected product.
   *
   * @generated from field: string guid = 1;
   */
  guid = "";

  /**
   * German display name (snapshot from products.name_de).
   *
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * One of the database.AvailabilityReason values
   * (out_of_stock, blocked, no_price, no_permission, ...).
   *
   * @generated from field: string reason = 3;
   */
  reason = "";

  constructor(data?: PartialMessage<SkippedOrderItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SkippedOrderItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "guid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkippedOrderItem {
    return new SkippedOrderItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkippedOrderItem {
    return new SkippedOrderItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkippedOrderItem {
    return new SkippedOrderItem().fromJsonString(jsonString, options);
  }

  static equals(a: SkippedOrderItem | PlainMessage<SkippedOrderItem> | undefined, b: SkippedOrderItem | PlainMessage<SkippedOrderItem> | undefined): boolean {
    return proto3.util.equals(SkippedOrderItem, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderSummaryRequest
 */
export class GetOrderSummaryRequest extends Message<GetOrderSummaryRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * If set, calculates summary for this existing order.
   *
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  /**
   * If order_id is empty, uses these quantities for calculation.
   * Map of product GUID -> quantity (as string).
   *
   * @generated from field: map<string, string> product_quantities = 3;
   */
  productQuantities: { [key: string]: string } = {};

  constructor(data?: PartialMessage<GetOrderSummaryRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderSummaryRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "product_quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderSummaryRequest {
    return new GetOrderSummaryRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderSummaryRequest {
    return new GetOrderSummaryRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderSummaryRequest {
    return new GetOrderSummaryRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderSummaryRequest | PlainMessage<GetOrderSummaryRequest> | undefined, b: GetOrderSummaryRequest | PlainMessage<GetOrderSummaryRequest> | undefined): boolean {
    return proto3.util.equals(GetOrderSummaryRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderSummaryResponse
 */
export class GetOrderSummaryResponse extends Message<GetOrderSummaryResponse> {
  /**
   * @generated from field: mw.common.OrderSummary order_summary = 1;
   */
  orderSummary?: OrderSummary;

  constructor(data?: PartialMessage<GetOrderSummaryResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderSummaryResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_summary", kind: "message", T: OrderSummary },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderSummaryResponse {
    return new GetOrderSummaryResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderSummaryResponse {
    return new GetOrderSummaryResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderSummaryResponse {
    return new GetOrderSummaryResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderSummaryResponse | PlainMessage<GetOrderSummaryResponse> | undefined, b: GetOrderSummaryResponse | PlainMessage<GetOrderSummaryResponse> | undefined): boolean {
    return proto3.util.equals(GetOrderSummaryResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.ClearProductQuantitiesRequest
 */
export class ClearProductQuantitiesRequest extends Message<ClearProductQuantitiesRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  constructor(data?: PartialMessage<ClearProductQuantitiesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ClearProductQuantitiesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearProductQuantitiesRequest {
    return new ClearProductQuantitiesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearProductQuantitiesRequest {
    return new ClearProductQuantitiesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearProductQuantitiesRequest {
    return new ClearProductQuantitiesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ClearProductQuantitiesRequest | PlainMessage<ClearProductQuantitiesRequest> | undefined, b: ClearProductQuantitiesRequest | PlainMessage<ClearProductQuantitiesRequest> | undefined): boolean {
    return proto3.util.equals(ClearProductQuantitiesRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.ClearProductQuantitiesResponse
 */
export class ClearProductQuantitiesResponse extends Message<ClearProductQuantitiesResponse> {
  constructor(data?: PartialMessage<ClearProductQuantitiesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ClearProductQuantitiesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ClearProductQuantitiesResponse {
    return new ClearProductQuantitiesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ClearProductQuantitiesResponse {
    return new ClearProductQuantitiesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ClearProductQuantitiesResponse {
    return new ClearProductQuantitiesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ClearProductQuantitiesResponse | PlainMessage<ClearProductQuantitiesResponse> | undefined, b: ClearProductQuantitiesResponse | PlainMessage<ClearProductQuantitiesResponse> | undefined): boolean {
    return proto3.util.equals(ClearProductQuantitiesResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.DownloadInvoicePDFRequest
 */
export class DownloadInvoicePDFRequest extends Message<DownloadInvoicePDFRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * Order GUID.
   *
   * @generated from field: string order_id = 2;
   */
  orderId = "";

  constructor(data?: PartialMessage<DownloadInvoicePDFRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.DownloadInvoicePDFRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadInvoicePDFRequest {
    return new DownloadInvoicePDFRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadInvoicePDFRequest {
    return new DownloadInvoicePDFRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadInvoicePDFRequest {
    return new DownloadInvoicePDFRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadInvoicePDFRequest | PlainMessage<DownloadInvoicePDFRequest> | undefined, b: DownloadInvoicePDFRequest | PlainMessage<DownloadInvoicePDFRequest> | undefined): boolean {
    return proto3.util.equals(DownloadInvoicePDFRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.DownloadInvoicePDFResponse
 */
export class DownloadInvoicePDFResponse extends Message<DownloadInvoicePDFResponse> {
  /**
   * @generated from field: bytes data = 1;
   */
  data = new Uint8Array(0);

  /**
   * @generated from field: string filename = 2;
   */
  filename = "";

  /**
   * @generated from field: string file_extension = 3;
   */
  fileExtension = "";

  constructor(data?: PartialMessage<DownloadInvoicePDFResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.DownloadInvoicePDFResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_extension", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DownloadInvoicePDFResponse {
    return new DownloadInvoicePDFResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DownloadInvoicePDFResponse {
    return new DownloadInvoicePDFResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DownloadInvoicePDFResponse {
    return new DownloadInvoicePDFResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DownloadInvoicePDFResponse | PlainMessage<DownloadInvoicePDFResponse> | undefined, b: DownloadInvoicePDFResponse | PlainMessage<DownloadInvoicePDFResponse> | undefined): boolean {
    return proto3.util.equals(DownloadInvoicePDFResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderFormV2Request
 */
export class GetOrderFormV2Request extends Message<GetOrderFormV2Request> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * Order form identifier (e.g. "b2b", "student").
   *
   * @generated from field: string order_form = 2;
   */
  orderForm = "";

  constructor(data?: PartialMessage<GetOrderFormV2Request>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderFormV2Request";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_form", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderFormV2Request {
    return new GetOrderFormV2Request().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderFormV2Request {
    return new GetOrderFormV2Request().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderFormV2Request {
    return new GetOrderFormV2Request().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderFormV2Request | PlainMessage<GetOrderFormV2Request> | undefined, b: GetOrderFormV2Request | PlainMessage<GetOrderFormV2Request> | undefined): boolean {
    return proto3.util.equals(GetOrderFormV2Request, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderFormV2Response
 */
export class GetOrderFormV2Response extends Message<GetOrderFormV2Response> {
  /**
   * @generated from field: repeated mw.common.OrderFormV2Category categories = 1;
   */
  categories: OrderFormV2Category[] = [];

  constructor(data?: PartialMessage<GetOrderFormV2Response>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderFormV2Response";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "categories", kind: "message", T: OrderFormV2Category, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderFormV2Response {
    return new GetOrderFormV2Response().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderFormV2Response {
    return new GetOrderFormV2Response().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderFormV2Response {
    return new GetOrderFormV2Response().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderFormV2Response | PlainMessage<GetOrderFormV2Response> | undefined, b: GetOrderFormV2Response | PlainMessage<GetOrderFormV2Response> | undefined): boolean {
    return proto3.util.equals(GetOrderFormV2Response, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderFormV2GroupedRequest
 */
export class GetOrderFormV2GroupedRequest extends Message<GetOrderFormV2GroupedRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * @generated from field: string order_form = 2;
   */
  orderForm = "";

  /**
   * Optional: filter by specific category.
   *
   * @generated from field: string category = 3;
   */
  category = "";

  /**
   * Screen size hint: 1 = mobile, 2 = tablet/desktop, 3 = large desktop.
   * Used to optimize column count in the response.
   *
   * @generated from field: int32 screen_size = 4;
   */
  screenSize = 0;

  constructor(data?: PartialMessage<GetOrderFormV2GroupedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderFormV2GroupedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_form", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "screen_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderFormV2GroupedRequest {
    return new GetOrderFormV2GroupedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderFormV2GroupedRequest {
    return new GetOrderFormV2GroupedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderFormV2GroupedRequest {
    return new GetOrderFormV2GroupedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderFormV2GroupedRequest | PlainMessage<GetOrderFormV2GroupedRequest> | undefined, b: GetOrderFormV2GroupedRequest | PlainMessage<GetOrderFormV2GroupedRequest> | undefined): boolean {
    return proto3.util.equals(GetOrderFormV2GroupedRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetOrderFormV2GroupedResponse
 */
export class GetOrderFormV2GroupedResponse extends Message<GetOrderFormV2GroupedResponse> {
  /**
   * @generated from field: repeated mw.common.OrderFormV2CategoryGrouped categories = 1;
   */
  categories: OrderFormV2CategoryGrouped[] = [];

  constructor(data?: PartialMessage<GetOrderFormV2GroupedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetOrderFormV2GroupedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "categories", kind: "message", T: OrderFormV2CategoryGrouped, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetOrderFormV2GroupedResponse {
    return new GetOrderFormV2GroupedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetOrderFormV2GroupedResponse {
    return new GetOrderFormV2GroupedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetOrderFormV2GroupedResponse {
    return new GetOrderFormV2GroupedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetOrderFormV2GroupedResponse | PlainMessage<GetOrderFormV2GroupedResponse> | undefined, b: GetOrderFormV2GroupedResponse | PlainMessage<GetOrderFormV2GroupedResponse> | undefined): boolean {
    return proto3.util.equals(GetOrderFormV2GroupedResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetMiniShopRequest
 */
export class GetMiniShopRequest extends Message<GetMiniShopRequest> {
  /**
   * URL-safe shop name.
   *
   * @generated from field: string shop_name = 1;
   */
  shopName = "";

  /**
   * Visitor ID (anonymous tracking cookie).
   *
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * Referrer identifier.
   *
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * Whether the visitor came via QR code.
   *
   * @generated from field: bool qr = 4;
   */
  qr = false;

  /**
   * JSON-encoded user agent data.
   *
   * @generated from field: string ua = 5;
   */
  ua = "";

  /**
   * Pre-filled email (from URL parameter).
   *
   * @generated from field: string email = 6;
   */
  email = "";

  /**
   * Campaign tracking parameters.
   *
   * @generated from field: string fbclid = 7;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 8;
   */
  gclid = "";

  constructor(data?: PartialMessage<GetMiniShopRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetMiniShopRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qr", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ua", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMiniShopRequest {
    return new GetMiniShopRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMiniShopRequest {
    return new GetMiniShopRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMiniShopRequest {
    return new GetMiniShopRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetMiniShopRequest | PlainMessage<GetMiniShopRequest> | undefined, b: GetMiniShopRequest | PlainMessage<GetMiniShopRequest> | undefined): boolean {
    return proto3.util.equals(GetMiniShopRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetMiniShopResponse
 */
export class GetMiniShopResponse extends Message<GetMiniShopResponse> {
  /**
   * @generated from field: mw.common.MiniShop shop = 1;
   */
  shop?: MiniShop;

  /**
   * Visitor ID (may be newly generated).
   *
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * Map of special_offer_id -> remaining quantity (based on max_quantity_per_customer).
   *
   * @generated from field: map<string, int32> remaining_quantities = 3;
   */
  remainingQuantities: { [key: string]: number } = {};

  constructor(data?: PartialMessage<GetMiniShopResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetMiniShopResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shop", kind: "message", T: MiniShop },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "remaining_quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetMiniShopResponse {
    return new GetMiniShopResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetMiniShopResponse {
    return new GetMiniShopResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetMiniShopResponse {
    return new GetMiniShopResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetMiniShopResponse | PlainMessage<GetMiniShopResponse> | undefined, b: GetMiniShopResponse | PlainMessage<GetMiniShopResponse> | undefined): boolean {
    return proto3.util.equals(GetMiniShopResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.ValidateMiniShopOrderRequest
 */
export class ValidateMiniShopOrderRequest extends Message<ValidateMiniShopOrderRequest> {
  /**
   * @generated from field: string shop_name = 1;
   */
  shopName = "";

  /**
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * @generated from field: bool qr = 4;
   */
  qr = false;

  /**
   * @generated from field: string ua = 5;
   */
  ua = "";

  /**
   * Map of special_offer_id -> desired quantity.
   *
   * @generated from field: map<string, int32> quantities = 6;
   */
  quantities: { [key: string]: number } = {};

  /**
   * @generated from field: mw.common.Address invoice_address = 7;
   */
  invoiceAddress?: Address;

  /**
   * @generated from field: mw.common.Address delivery_address = 8;
   */
  deliveryAddress?: Address;

  /**
   * @generated from field: string email = 9;
   */
  email = "";

  /**
   * @generated from field: string fbclid = 10;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 11;
   */
  gclid = "";

  constructor(data?: PartialMessage<ValidateMiniShopOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ValidateMiniShopOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qr", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ua", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 7, name: "invoice_address", kind: "message", T: Address },
    { no: 8, name: "delivery_address", kind: "message", T: Address },
    { no: 9, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateMiniShopOrderRequest {
    return new ValidateMiniShopOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateMiniShopOrderRequest {
    return new ValidateMiniShopOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateMiniShopOrderRequest {
    return new ValidateMiniShopOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateMiniShopOrderRequest | PlainMessage<ValidateMiniShopOrderRequest> | undefined, b: ValidateMiniShopOrderRequest | PlainMessage<ValidateMiniShopOrderRequest> | undefined): boolean {
    return proto3.util.equals(ValidateMiniShopOrderRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.ValidateMiniShopOrderResponse
 */
export class ValidateMiniShopOrderResponse extends Message<ValidateMiniShopOrderResponse> {
  /**
   * Validation errors: field_name -> error message. Empty map = valid.
   *
   * @generated from field: map<string, string> messages = 1;
   */
  messages: { [key: string]: string } = {};

  /**
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * Calculated order totals (formatted strings).
   *
   * @generated from field: string total_without_vat = 3;
   */
  totalWithoutVat = "";

  /**
   * @generated from field: string total_with_vat = 4;
   */
  totalWithVat = "";

  /**
   * @generated from field: string vat_percentage = 5;
   */
  vatPercentage = "";

  /**
   * @generated from field: string vat_value = 6;
   */
  vatValue = "";

  /**
   * Updated remaining quantities after this order.
   *
   * @generated from field: map<string, int32> remaining_quantities = 7;
   */
  remainingQuantities: { [key: string]: number } = {};

  constructor(data?: PartialMessage<ValidateMiniShopOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ValidateMiniShopOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "messages", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "total_without_vat", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "total_with_vat", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "vat_percentage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "vat_value", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "remaining_quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateMiniShopOrderResponse {
    return new ValidateMiniShopOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateMiniShopOrderResponse {
    return new ValidateMiniShopOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateMiniShopOrderResponse {
    return new ValidateMiniShopOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateMiniShopOrderResponse | PlainMessage<ValidateMiniShopOrderResponse> | undefined, b: ValidateMiniShopOrderResponse | PlainMessage<ValidateMiniShopOrderResponse> | undefined): boolean {
    return proto3.util.equals(ValidateMiniShopOrderResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.CreateMiniShopOrderRequest
 */
export class CreateMiniShopOrderRequest extends Message<CreateMiniShopOrderRequest> {
  /**
   * @generated from field: string shop_name = 1;
   */
  shopName = "";

  /**
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * @generated from field: bool qr = 4;
   */
  qr = false;

  /**
   * @generated from field: string ua = 5;
   */
  ua = "";

  /**
   * Map of special_offer_id -> quantity.
   *
   * @generated from field: map<string, int32> quantities = 6;
   */
  quantities: { [key: string]: number } = {};

  /**
   * @generated from field: mw.common.Address invoice_address = 7;
   */
  invoiceAddress?: Address;

  /**
   * @generated from field: mw.common.Address delivery_address = 8;
   */
  deliveryAddress?: Address;

  /**
   * @generated from field: string email = 9;
   */
  email = "";

  /**
   * Consent flags: consent_type -> "true"/"false".
   *
   * @generated from field: map<string, string> consents = 10;
   */
  consents: { [key: string]: string } = {};

  /**
   * @generated from field: string fbclid = 11;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 12;
   */
  gclid = "";

  constructor(data?: PartialMessage<CreateMiniShopOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CreateMiniShopOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "shop_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qr", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ua", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "quantities", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 5 /* ScalarType.INT32 */} },
    { no: 7, name: "invoice_address", kind: "message", T: Address },
    { no: 8, name: "delivery_address", kind: "message", T: Address },
    { no: 9, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "consents", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 11, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMiniShopOrderRequest {
    return new CreateMiniShopOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMiniShopOrderRequest {
    return new CreateMiniShopOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMiniShopOrderRequest {
    return new CreateMiniShopOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMiniShopOrderRequest | PlainMessage<CreateMiniShopOrderRequest> | undefined, b: CreateMiniShopOrderRequest | PlainMessage<CreateMiniShopOrderRequest> | undefined): boolean {
    return proto3.util.equals(CreateMiniShopOrderRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.CreateMiniShopOrderResponse
 */
export class CreateMiniShopOrderResponse extends Message<CreateMiniShopOrderResponse> {
  /**
   * Internal order GUID.
   *
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * PayPal order ID (used for buyer approval redirect).
   *
   * @generated from field: string paypal_order_id = 2;
   */
  paypalOrderId = "";

  /**
   * Validation errors (empty if order was created successfully).
   *
   * @generated from field: map<string, string> messages = 3;
   */
  messages: { [key: string]: string } = {};

  /**
   * @generated from field: string vid = 4;
   */
  vid = "";

  constructor(data?: PartialMessage<CreateMiniShopOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CreateMiniShopOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "paypal_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "messages", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 4, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateMiniShopOrderResponse {
    return new CreateMiniShopOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateMiniShopOrderResponse {
    return new CreateMiniShopOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateMiniShopOrderResponse {
    return new CreateMiniShopOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateMiniShopOrderResponse | PlainMessage<CreateMiniShopOrderResponse> | undefined, b: CreateMiniShopOrderResponse | PlainMessage<CreateMiniShopOrderResponse> | undefined): boolean {
    return proto3.util.equals(CreateMiniShopOrderResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.CaptureMiniShopOrderRequest
 */
export class CaptureMiniShopOrderRequest extends Message<CaptureMiniShopOrderRequest> {
  /**
   * Internal order GUID.
   *
   * @generated from field: string order_id = 1;
   */
  orderId = "";

  /**
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * @generated from field: bool qr = 4;
   */
  qr = false;

  /**
   * @generated from field: string ua = 5;
   */
  ua = "";

  /**
   * If true, generate an invoice instead of capturing PayPal.
   * Only available for students with prior PayPal orders and amount < 1000 EUR.
   *
   * @generated from field: bool invoice = 6;
   */
  invoice = false;

  /**
   * @generated from field: string fbclid = 7;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 8;
   */
  gclid = "";

  constructor(data?: PartialMessage<CaptureMiniShopOrderRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CaptureMiniShopOrderRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qr", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ua", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CaptureMiniShopOrderRequest {
    return new CaptureMiniShopOrderRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CaptureMiniShopOrderRequest {
    return new CaptureMiniShopOrderRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CaptureMiniShopOrderRequest {
    return new CaptureMiniShopOrderRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CaptureMiniShopOrderRequest | PlainMessage<CaptureMiniShopOrderRequest> | undefined, b: CaptureMiniShopOrderRequest | PlainMessage<CaptureMiniShopOrderRequest> | undefined): boolean {
    return proto3.util.equals(CaptureMiniShopOrderRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.CaptureMiniShopOrderResponse
 */
export class CaptureMiniShopOrderResponse extends Message<CaptureMiniShopOrderResponse> {
  /**
   * @generated from field: string message = 1;
   */
  message = "";

  /**
   * @generated from field: string vid = 2;
   */
  vid = "";

  constructor(data?: PartialMessage<CaptureMiniShopOrderResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.CaptureMiniShopOrderResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CaptureMiniShopOrderResponse {
    return new CaptureMiniShopOrderResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CaptureMiniShopOrderResponse {
    return new CaptureMiniShopOrderResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CaptureMiniShopOrderResponse {
    return new CaptureMiniShopOrderResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CaptureMiniShopOrderResponse | PlainMessage<CaptureMiniShopOrderResponse> | undefined, b: CaptureMiniShopOrderResponse | PlainMessage<CaptureMiniShopOrderResponse> | undefined): boolean {
    return proto3.util.equals(CaptureMiniShopOrderResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.ValidateAddressRequest
 */
export class ValidateAddressRequest extends Message<ValidateAddressRequest> {
  /**
   * @generated from field: mw.common.Address address = 1;
   */
  address?: Address;

  constructor(data?: PartialMessage<ValidateAddressRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ValidateAddressRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "address", kind: "message", T: Address },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateAddressRequest {
    return new ValidateAddressRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateAddressRequest {
    return new ValidateAddressRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateAddressRequest {
    return new ValidateAddressRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateAddressRequest | PlainMessage<ValidateAddressRequest> | undefined, b: ValidateAddressRequest | PlainMessage<ValidateAddressRequest> | undefined): boolean {
    return proto3.util.equals(ValidateAddressRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.ValidateAddressResponse
 */
export class ValidateAddressResponse extends Message<ValidateAddressResponse> {
  /**
   * Field-level validation errors: "ADDRESS_TYPE.field_name" -> error message.
   *
   * @generated from field: map<string, string> messages = 1;
   */
  messages: { [key: string]: string } = {};

  constructor(data?: PartialMessage<ValidateAddressResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ValidateAddressResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "messages", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ValidateAddressResponse {
    return new ValidateAddressResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ValidateAddressResponse {
    return new ValidateAddressResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ValidateAddressResponse {
    return new ValidateAddressResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ValidateAddressResponse | PlainMessage<ValidateAddressResponse> | undefined, b: ValidateAddressResponse | PlainMessage<ValidateAddressResponse> | undefined): boolean {
    return proto3.util.equals(ValidateAddressResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.TrackUsageRequest
 */
export class TrackUsageRequest extends Message<TrackUsageRequest> {
  /**
   * @generated from field: mw.common.UsageType usage_type = 1;
   */
  usageType = UsageType.INVALID;

  /**
   * Visitor ID.
   *
   * @generated from field: string vid = 2;
   */
  vid = "";

  /**
   * @generated from field: string ref = 3;
   */
  ref = "";

  /**
   * @generated from field: bool qr = 4;
   */
  qr = false;

  /**
   * JSON-encoded user agent data.
   *
   * @generated from field: string ua = 5;
   */
  ua = "";

  /**
   * Order GUID (if tracking an order event).
   *
   * @generated from field: string order_id = 6;
   */
  orderId = "";

  /**
   * @generated from field: string fbclid = 7;
   */
  fbclid = "";

  /**
   * @generated from field: string gclid = 8;
   */
  gclid = "";

  constructor(data?: PartialMessage<TrackUsageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.TrackUsageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "usage_type", kind: "enum", T: proto3.getEnumType(UsageType) },
    { no: 2, name: "vid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "qr", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "ua", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "fbclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "gclid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackUsageRequest {
    return new TrackUsageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackUsageRequest {
    return new TrackUsageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackUsageRequest {
    return new TrackUsageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: TrackUsageRequest | PlainMessage<TrackUsageRequest> | undefined, b: TrackUsageRequest | PlainMessage<TrackUsageRequest> | undefined): boolean {
    return proto3.util.equals(TrackUsageRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.TrackUsageResponse
 */
export class TrackUsageResponse extends Message<TrackUsageResponse> {
  constructor(data?: PartialMessage<TrackUsageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.TrackUsageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackUsageResponse {
    return new TrackUsageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackUsageResponse {
    return new TrackUsageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackUsageResponse {
    return new TrackUsageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: TrackUsageResponse | PlainMessage<TrackUsageResponse> | undefined, b: TrackUsageResponse | PlainMessage<TrackUsageResponse> | undefined): boolean {
    return proto3.util.equals(TrackUsageResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.ErrorRequest
 */
export class ErrorRequest extends Message<ErrorRequest> {
  /**
   * Frontend error message / stack trace.
   *
   * @generated from field: string error = 1;
   */
  error = "";

  constructor(data?: PartialMessage<ErrorRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ErrorRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ErrorRequest {
    return new ErrorRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ErrorRequest {
    return new ErrorRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ErrorRequest {
    return new ErrorRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ErrorRequest | PlainMessage<ErrorRequest> | undefined, b: ErrorRequest | PlainMessage<ErrorRequest> | undefined): boolean {
    return proto3.util.equals(ErrorRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.ErrorResponse
 */
export class ErrorResponse extends Message<ErrorResponse> {
  constructor(data?: PartialMessage<ErrorResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ErrorResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ErrorResponse {
    return new ErrorResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ErrorResponse {
    return new ErrorResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ErrorResponse {
    return new ErrorResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ErrorResponse | PlainMessage<ErrorResponse> | undefined, b: ErrorResponse | PlainMessage<ErrorResponse> | undefined): boolean {
    return proto3.util.equals(ErrorResponse, a, b);
  }
}

/**
 * SkinAnalysisImageRequirement defines a required photo angle for skin analysis.
 *
 * @generated from message mw.customer.SkinAnalysisImageRequirement
 */
export class SkinAnalysisImageRequirement extends Message<SkinAnalysisImageRequirement> {
  /**
   * Position identifier (e.g. "left_angle", "right_angle", "front").
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string label_en = 2;
   */
  labelEn = "";

  /**
   * @generated from field: string label_de = 3;
   */
  labelDe = "";

  /**
   * @generated from field: string description_en = 4;
   */
  descriptionEn = "";

  /**
   * @generated from field: string description_de = 5;
   */
  descriptionDe = "";

  /**
   * Whether this photo is mandatory.
   *
   * @generated from field: bool required = 6;
   */
  required = false;

  constructor(data?: PartialMessage<SkinAnalysisImageRequirement>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SkinAnalysisImageRequirement";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "required", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkinAnalysisImageRequirement {
    return new SkinAnalysisImageRequirement().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkinAnalysisImageRequirement {
    return new SkinAnalysisImageRequirement().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkinAnalysisImageRequirement {
    return new SkinAnalysisImageRequirement().fromJsonString(jsonString, options);
  }

  static equals(a: SkinAnalysisImageRequirement | PlainMessage<SkinAnalysisImageRequirement> | undefined, b: SkinAnalysisImageRequirement | PlainMessage<SkinAnalysisImageRequirement> | undefined): boolean {
    return proto3.util.equals(SkinAnalysisImageRequirement, a, b);
  }
}

/**
 * SkinAnalysisSlider defines a self-assessment slider for a skin problem.
 *
 * @generated from message mw.customer.SkinAnalysisSlider
 */
export class SkinAnalysisSlider extends Message<SkinAnalysisSlider> {
  /**
   * @generated from field: uint32 skin_problem_id = 1;
   */
  skinProblemId = 0;

  /**
   * @generated from field: string label_en = 2;
   */
  labelEn = "";

  /**
   * @generated from field: string label_de = 3;
   */
  labelDe = "";

  /**
   * @generated from field: string description_en = 4;
   */
  descriptionEn = "";

  /**
   * @generated from field: string description_de = 5;
   */
  descriptionDe = "";

  /**
   * Default slider value (0-100).
   *
   * @generated from field: uint32 default_value = 6;
   */
  defaultValue = 0;

  constructor(data?: PartialMessage<SkinAnalysisSlider>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SkinAnalysisSlider";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "skin_problem_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "label_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description_en", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description_de", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "default_value", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkinAnalysisSlider {
    return new SkinAnalysisSlider().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkinAnalysisSlider {
    return new SkinAnalysisSlider().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkinAnalysisSlider {
    return new SkinAnalysisSlider().fromJsonString(jsonString, options);
  }

  static equals(a: SkinAnalysisSlider | PlainMessage<SkinAnalysisSlider> | undefined, b: SkinAnalysisSlider | PlainMessage<SkinAnalysisSlider> | undefined): boolean {
    return proto3.util.equals(SkinAnalysisSlider, a, b);
  }
}

/**
 * @generated from message mw.customer.GetSkinAnalysisFormRequest
 */
export class GetSkinAnalysisFormRequest extends Message<GetSkinAnalysisFormRequest> {
  /**
   * Language code: "en" or "de".
   *
   * @generated from field: string language = 1;
   */
  language = "";

  constructor(data?: PartialMessage<GetSkinAnalysisFormRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSkinAnalysisFormRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSkinAnalysisFormRequest {
    return new GetSkinAnalysisFormRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSkinAnalysisFormRequest {
    return new GetSkinAnalysisFormRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSkinAnalysisFormRequest {
    return new GetSkinAnalysisFormRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSkinAnalysisFormRequest | PlainMessage<GetSkinAnalysisFormRequest> | undefined, b: GetSkinAnalysisFormRequest | PlainMessage<GetSkinAnalysisFormRequest> | undefined): boolean {
    return proto3.util.equals(GetSkinAnalysisFormRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetSkinAnalysisFormResponse
 */
export class GetSkinAnalysisFormResponse extends Message<GetSkinAnalysisFormResponse> {
  /**
   * Required photo angles.
   *
   * @generated from field: repeated mw.customer.SkinAnalysisImageRequirement image_requirements = 1;
   */
  imageRequirements: SkinAnalysisImageRequirement[] = [];

  /**
   * Self-assessment sliders for non-AI-detectable problems.
   *
   * @generated from field: repeated mw.customer.SkinAnalysisSlider user_input_sliders = 2;
   */
  userInputSliders: SkinAnalysisSlider[] = [];

  constructor(data?: PartialMessage<GetSkinAnalysisFormResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSkinAnalysisFormResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "image_requirements", kind: "message", T: SkinAnalysisImageRequirement, repeated: true },
    { no: 2, name: "user_input_sliders", kind: "message", T: SkinAnalysisSlider, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSkinAnalysisFormResponse {
    return new GetSkinAnalysisFormResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSkinAnalysisFormResponse {
    return new GetSkinAnalysisFormResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSkinAnalysisFormResponse {
    return new GetSkinAnalysisFormResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSkinAnalysisFormResponse | PlainMessage<GetSkinAnalysisFormResponse> | undefined, b: GetSkinAnalysisFormResponse | PlainMessage<GetSkinAnalysisFormResponse> | undefined): boolean {
    return proto3.util.equals(GetSkinAnalysisFormResponse, a, b);
  }
}

/**
 * SkinImage contains a photo uploaded for AI analysis.
 *
 * @generated from message mw.customer.SkinImage
 */
export class SkinImage extends Message<SkinImage> {
  /**
   * Corresponds to SkinAnalysisImageRequirement.id.
   *
   * @generated from field: string image_id = 1;
   */
  imageId = "";

  /**
   * @generated from field: bytes image_data = 2;
   */
  imageData = new Uint8Array(0);

  /**
   * @generated from field: string mime_type = 3;
   */
  mimeType = "";

  constructor(data?: PartialMessage<SkinImage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SkinImage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "image_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "image_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 3, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkinImage {
    return new SkinImage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkinImage {
    return new SkinImage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkinImage {
    return new SkinImage().fromJsonString(jsonString, options);
  }

  static equals(a: SkinImage | PlainMessage<SkinImage> | undefined, b: SkinImage | PlainMessage<SkinImage> | undefined): boolean {
    return proto3.util.equals(SkinImage, a, b);
  }
}

/**
 * @generated from message mw.customer.AnalyzeSkinProblemsRequest
 */
export class AnalyzeSkinProblemsRequest extends Message<AnalyzeSkinProblemsRequest> {
  /**
   * @generated from field: repeated mw.customer.SkinImage images = 1;
   */
  images: SkinImage[] = [];

  /**
   * User self-assessment scores: skin_problem_id -> score (0-100).
   *
   * @generated from field: map<uint32, uint32> user_scores = 2;
   */
  userScores: { [key: number]: number } = {};

  constructor(data?: PartialMessage<AnalyzeSkinProblemsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AnalyzeSkinProblemsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "images", kind: "message", T: SkinImage, repeated: true },
    { no: 2, name: "user_scores", kind: "map", K: 13 /* ScalarType.UINT32 */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnalyzeSkinProblemsRequest {
    return new AnalyzeSkinProblemsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnalyzeSkinProblemsRequest {
    return new AnalyzeSkinProblemsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnalyzeSkinProblemsRequest {
    return new AnalyzeSkinProblemsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AnalyzeSkinProblemsRequest | PlainMessage<AnalyzeSkinProblemsRequest> | undefined, b: AnalyzeSkinProblemsRequest | PlainMessage<AnalyzeSkinProblemsRequest> | undefined): boolean {
    return proto3.util.equals(AnalyzeSkinProblemsRequest, a, b);
  }
}

/**
 * SkinProblemScore contains the analysis result for one skin problem.
 *
 * @generated from message mw.customer.SkinProblemScore
 */
export class SkinProblemScore extends Message<SkinProblemScore> {
  /**
   * @generated from field: uint32 skin_problem_id = 1;
   */
  skinProblemId = 0;

  /**
   * @generated from field: mw.common.SkinProblem skin_problem = 2;
   */
  skinProblem?: SkinProblem;

  /**
   * AI-detected severity (0-100).
   *
   * @generated from field: uint32 ai_score = 3;
   */
  aiScore = 0;

  /**
   * User self-assessed severity (0-100).
   *
   * @generated from field: uint32 user_score = 4;
   */
  userScore = 0;

  /**
   * Combined final score (0-100).
   *
   * @generated from field: uint32 final_score = 5;
   */
  finalScore = 0;

  constructor(data?: PartialMessage<SkinProblemScore>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.SkinProblemScore";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "skin_problem_id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "skin_problem", kind: "message", T: SkinProblem },
    { no: 3, name: "ai_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "user_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "final_score", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): SkinProblemScore {
    return new SkinProblemScore().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): SkinProblemScore {
    return new SkinProblemScore().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): SkinProblemScore {
    return new SkinProblemScore().fromJsonString(jsonString, options);
  }

  static equals(a: SkinProblemScore | PlainMessage<SkinProblemScore> | undefined, b: SkinProblemScore | PlainMessage<SkinProblemScore> | undefined): boolean {
    return proto3.util.equals(SkinProblemScore, a, b);
  }
}

/**
 * @generated from message mw.customer.AnalyzeSkinProblemsResponse
 */
export class AnalyzeSkinProblemsResponse extends Message<AnalyzeSkinProblemsResponse> {
  /**
   * @generated from field: repeated mw.customer.SkinProblemScore problem_scores = 1;
   */
  problemScores: SkinProblemScore[] = [];

  /**
   * Tracking ID for this analysis session.
   *
   * @generated from field: string analysis_id = 2;
   */
  analysisId = "";

  constructor(data?: PartialMessage<AnalyzeSkinProblemsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AnalyzeSkinProblemsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "problem_scores", kind: "message", T: SkinProblemScore, repeated: true },
    { no: 2, name: "analysis_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnalyzeSkinProblemsResponse {
    return new AnalyzeSkinProblemsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnalyzeSkinProblemsResponse {
    return new AnalyzeSkinProblemsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnalyzeSkinProblemsResponse {
    return new AnalyzeSkinProblemsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AnalyzeSkinProblemsResponse | PlainMessage<AnalyzeSkinProblemsResponse> | undefined, b: AnalyzeSkinProblemsResponse | PlainMessage<AnalyzeSkinProblemsResponse> | undefined): boolean {
    return proto3.util.equals(AnalyzeSkinProblemsResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetProductRecommendationsRequest
 */
export class GetProductRecommendationsRequest extends Message<GetProductRecommendationsRequest> {
  /**
   * Skin problem scores from AnalyzeSkinProblems.
   *
   * @generated from field: repeated mw.customer.SkinProblemScore problem_scores = 1;
   */
  problemScores: SkinProblemScore[] = [];

  /**
   * Maximum number of products to return.
   *
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<GetProductRecommendationsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetProductRecommendationsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "problem_scores", kind: "message", T: SkinProblemScore, repeated: true },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProductRecommendationsRequest {
    return new GetProductRecommendationsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProductRecommendationsRequest {
    return new GetProductRecommendationsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProductRecommendationsRequest {
    return new GetProductRecommendationsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetProductRecommendationsRequest | PlainMessage<GetProductRecommendationsRequest> | undefined, b: GetProductRecommendationsRequest | PlainMessage<GetProductRecommendationsRequest> | undefined): boolean {
    return proto3.util.equals(GetProductRecommendationsRequest, a, b);
  }
}

/**
 * ProductRecommendation pairs a product with its weighted effectiveness.
 *
 * @generated from message mw.customer.ProductRecommendation
 */
export class ProductRecommendation extends Message<ProductRecommendation> {
  /**
   * @generated from field: mw.common.Product product = 1;
   */
  product?: Product;

  /**
   * Weighted effectiveness across all detected skin problems.
   *
   * @generated from field: float effectiveness_score = 2;
   */
  effectivenessScore = 0;

  /**
   * Per-problem breakdown: skin_problem_id -> effectiveness for this product.
   *
   * @generated from field: map<uint32, uint32> problem_scores = 3;
   */
  problemScores: { [key: number]: number } = {};

  constructor(data?: PartialMessage<ProductRecommendation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ProductRecommendation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "product", kind: "message", T: Product },
    { no: 2, name: "effectiveness_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "problem_scores", kind: "map", K: 13 /* ScalarType.UINT32 */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductRecommendation {
    return new ProductRecommendation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductRecommendation {
    return new ProductRecommendation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductRecommendation {
    return new ProductRecommendation().fromJsonString(jsonString, options);
  }

  static equals(a: ProductRecommendation | PlainMessage<ProductRecommendation> | undefined, b: ProductRecommendation | PlainMessage<ProductRecommendation> | undefined): boolean {
    return proto3.util.equals(ProductRecommendation, a, b);
  }
}

/**
 * @generated from message mw.customer.GetProductRecommendationsResponse
 */
export class GetProductRecommendationsResponse extends Message<GetProductRecommendationsResponse> {
  /**
   * @generated from field: repeated mw.customer.ProductRecommendation recommendations = 1;
   */
  recommendations: ProductRecommendation[] = [];

  constructor(data?: PartialMessage<GetProductRecommendationsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetProductRecommendationsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "recommendations", kind: "message", T: ProductRecommendation, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetProductRecommendationsResponse {
    return new GetProductRecommendationsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetProductRecommendationsResponse {
    return new GetProductRecommendationsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetProductRecommendationsResponse {
    return new GetProductRecommendationsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetProductRecommendationsResponse | PlainMessage<GetProductRecommendationsResponse> | undefined, b: GetProductRecommendationsResponse | PlainMessage<GetProductRecommendationsResponse> | undefined): boolean {
    return proto3.util.equals(GetProductRecommendationsResponse, a, b);
  }
}

/**
 * No authentication required (public endpoint).
 *
 * @generated from message mw.customer.GetSkinProblemsForAnalysisRequest
 */
export class GetSkinProblemsForAnalysisRequest extends Message<GetSkinProblemsForAnalysisRequest> {
  constructor(data?: PartialMessage<GetSkinProblemsForAnalysisRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSkinProblemsForAnalysisRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSkinProblemsForAnalysisRequest {
    return new GetSkinProblemsForAnalysisRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSkinProblemsForAnalysisRequest {
    return new GetSkinProblemsForAnalysisRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSkinProblemsForAnalysisRequest {
    return new GetSkinProblemsForAnalysisRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSkinProblemsForAnalysisRequest | PlainMessage<GetSkinProblemsForAnalysisRequest> | undefined, b: GetSkinProblemsForAnalysisRequest | PlainMessage<GetSkinProblemsForAnalysisRequest> | undefined): boolean {
    return proto3.util.equals(GetSkinProblemsForAnalysisRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetSkinProblemsForAnalysisResponse
 */
export class GetSkinProblemsForAnalysisResponse extends Message<GetSkinProblemsForAnalysisResponse> {
  /**
   * @generated from field: repeated mw.common.SkinProblem skin_problems = 1;
   */
  skinProblems: SkinProblem[] = [];

  /**
   * The AI analysis prompt (for frontend-driven analysis).
   *
   * @generated from field: string analysis_prompt = 2;
   */
  analysisPrompt = "";

  constructor(data?: PartialMessage<GetSkinProblemsForAnalysisResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSkinProblemsForAnalysisResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "skin_problems", kind: "message", T: SkinProblem, repeated: true },
    { no: 2, name: "analysis_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSkinProblemsForAnalysisResponse {
    return new GetSkinProblemsForAnalysisResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSkinProblemsForAnalysisResponse {
    return new GetSkinProblemsForAnalysisResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSkinProblemsForAnalysisResponse {
    return new GetSkinProblemsForAnalysisResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSkinProblemsForAnalysisResponse | PlainMessage<GetSkinProblemsForAnalysisResponse> | undefined, b: GetSkinProblemsForAnalysisResponse | PlainMessage<GetSkinProblemsForAnalysisResponse> | undefined): boolean {
    return proto3.util.equals(GetSkinProblemsForAnalysisResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.AnalyzeSkinImagesRequest
 */
export class AnalyzeSkinImagesRequest extends Message<AnalyzeSkinImagesRequest> {
  /**
   * Map of position_name -> image binary data.
   * Positions are dynamic and defined by the frontend.
   *
   * @generated from field: map<string, bytes> images = 1;
   */
  images: { [key: string]: Uint8Array } = {};

  constructor(data?: PartialMessage<AnalyzeSkinImagesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AnalyzeSkinImagesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "images", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 12 /* ScalarType.BYTES */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnalyzeSkinImagesRequest {
    return new AnalyzeSkinImagesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnalyzeSkinImagesRequest {
    return new AnalyzeSkinImagesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnalyzeSkinImagesRequest {
    return new AnalyzeSkinImagesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AnalyzeSkinImagesRequest | PlainMessage<AnalyzeSkinImagesRequest> | undefined, b: AnalyzeSkinImagesRequest | PlainMessage<AnalyzeSkinImagesRequest> | undefined): boolean {
    return proto3.util.equals(AnalyzeSkinImagesRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.AnalyzeSkinImagesResponse
 */
export class AnalyzeSkinImagesResponse extends Message<AnalyzeSkinImagesResponse> {
  /**
   * skin_problem_id -> severity score (0-100).
   *
   * @generated from field: map<uint32, uint32> analysis_results = 1;
   */
  analysisResults: { [key: number]: number } = {};

  /**
   * Tracking ID for this analysis session.
   *
   * @generated from field: string analysis_id = 2;
   */
  analysisId = "";

  constructor(data?: PartialMessage<AnalyzeSkinImagesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.AnalyzeSkinImagesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "analysis_results", kind: "map", K: 13 /* ScalarType.UINT32 */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
    { no: 2, name: "analysis_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AnalyzeSkinImagesResponse {
    return new AnalyzeSkinImagesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AnalyzeSkinImagesResponse {
    return new AnalyzeSkinImagesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AnalyzeSkinImagesResponse {
    return new AnalyzeSkinImagesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AnalyzeSkinImagesResponse | PlainMessage<AnalyzeSkinImagesResponse> | undefined, b: AnalyzeSkinImagesResponse | PlainMessage<AnalyzeSkinImagesResponse> | undefined): boolean {
    return proto3.util.equals(AnalyzeSkinImagesResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetSuggestedProductsRequest
 */
export class GetSuggestedProductsRequest extends Message<GetSuggestedProductsRequest> {
  /**
   * skin_problem_id -> user-adjusted severity score (0-100).
   *
   * @generated from field: map<uint32, uint32> skin_scores = 1;
   */
  skinScores: { [key: number]: number } = {};

  constructor(data?: PartialMessage<GetSuggestedProductsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSuggestedProductsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "skin_scores", kind: "map", K: 13 /* ScalarType.UINT32 */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedProductsRequest {
    return new GetSuggestedProductsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedProductsRequest {
    return new GetSuggestedProductsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedProductsRequest {
    return new GetSuggestedProductsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedProductsRequest | PlainMessage<GetSuggestedProductsRequest> | undefined, b: GetSuggestedProductsRequest | PlainMessage<GetSuggestedProductsRequest> | undefined): boolean {
    return proto3.util.equals(GetSuggestedProductsRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetSuggestedProductsResponse
 */
export class GetSuggestedProductsResponse extends Message<GetSuggestedProductsResponse> {
  /**
   * Recommended products sorted by effectiveness.
   *
   * @generated from field: repeated mw.common.Product products = 1;
   */
  products: Product[] = [];

  /**
   * product_id -> weighted effectiveness score.
   *
   * @generated from field: map<string, uint32> effectiveness_scores = 2;
   */
  effectivenessScores: { [key: string]: number } = {};

  /**
   * product_id -> skin problems this product addresses.
   *
   * @generated from field: map<string, mw.customer.ProductSkinProblems> product_skin_problems = 3;
   */
  productSkinProblems: { [key: string]: ProductSkinProblems } = {};

  constructor(data?: PartialMessage<GetSuggestedProductsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetSuggestedProductsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "products", kind: "message", T: Product, repeated: true },
    { no: 2, name: "effectiveness_scores", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
    { no: 3, name: "product_skin_problems", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: ProductSkinProblems} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSuggestedProductsResponse {
    return new GetSuggestedProductsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSuggestedProductsResponse {
    return new GetSuggestedProductsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSuggestedProductsResponse {
    return new GetSuggestedProductsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSuggestedProductsResponse | PlainMessage<GetSuggestedProductsResponse> | undefined, b: GetSuggestedProductsResponse | PlainMessage<GetSuggestedProductsResponse> | undefined): boolean {
    return proto3.util.equals(GetSuggestedProductsResponse, a, b);
  }
}

/**
 * ProductSkinProblems details which skin problems a product addresses.
 *
 * @generated from message mw.customer.ProductSkinProblems
 */
export class ProductSkinProblems extends Message<ProductSkinProblems> {
  /**
   * List of skin problem IDs this product is effective for.
   *
   * @generated from field: repeated uint32 skin_problem_ids = 1;
   */
  skinProblemIds: number[] = [];

  /**
   * skin_problem_id -> effectiveness score for this specific problem.
   *
   * @generated from field: map<uint32, uint32> problem_effectiveness = 2;
   */
  problemEffectiveness: { [key: number]: number } = {};

  constructor(data?: PartialMessage<ProductSkinProblems>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.ProductSkinProblems";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "skin_problem_ids", kind: "scalar", T: 13 /* ScalarType.UINT32 */, repeated: true },
    { no: 2, name: "problem_effectiveness", kind: "map", K: 13 /* ScalarType.UINT32 */, V: {kind: "scalar", T: 13 /* ScalarType.UINT32 */} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProductSkinProblems {
    return new ProductSkinProblems().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProductSkinProblems {
    return new ProductSkinProblems().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProductSkinProblems {
    return new ProductSkinProblems().fromJsonString(jsonString, options);
  }

  static equals(a: ProductSkinProblems | PlainMessage<ProductSkinProblems> | undefined, b: ProductSkinProblems | PlainMessage<ProductSkinProblems> | undefined): boolean {
    return proto3.util.equals(ProductSkinProblems, a, b);
  }
}

/**
 * @generated from message mw.customer.RegisterStudentRequest
 */
export class RegisterStudentRequest extends Message<RegisterStudentRequest> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  /**
   * @generated from field: mw.common.Address billing_address = 3;
   */
  billingAddress?: Address;

  /**
   * Optional: separate delivery address.
   *
   * @generated from field: mw.common.Address delivery_address = 4;
   */
  deliveryAddress?: Address;

  /**
   * Optional: verification documents uploaded during registration.
   *
   * @generated from field: repeated mw.customer.StudentDocument documents = 5;
   */
  documents: StudentDocument[] = [];

  constructor(data?: PartialMessage<RegisterStudentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.RegisterStudentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "billing_address", kind: "message", T: Address },
    { no: 4, name: "delivery_address", kind: "message", T: Address },
    { no: 5, name: "documents", kind: "message", T: StudentDocument, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterStudentRequest {
    return new RegisterStudentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterStudentRequest {
    return new RegisterStudentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterStudentRequest {
    return new RegisterStudentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterStudentRequest | PlainMessage<RegisterStudentRequest> | undefined, b: RegisterStudentRequest | PlainMessage<RegisterStudentRequest> | undefined): boolean {
    return proto3.util.equals(RegisterStudentRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.RegisterStudentResponse
 */
export class RegisterStudentResponse extends Message<RegisterStudentResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * Customer ID of the newly registered student.
   *
   * @generated from field: int32 customer_id = 3;
   */
  customerId = 0;

  constructor(data?: PartialMessage<RegisterStudentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.RegisterStudentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "customer_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RegisterStudentResponse {
    return new RegisterStudentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RegisterStudentResponse {
    return new RegisterStudentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RegisterStudentResponse {
    return new RegisterStudentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: RegisterStudentResponse | PlainMessage<RegisterStudentResponse> | undefined, b: RegisterStudentResponse | PlainMessage<RegisterStudentResponse> | undefined): boolean {
    return proto3.util.equals(RegisterStudentResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.VerifyStudentEmailRequest
 */
export class VerifyStudentEmailRequest extends Message<VerifyStudentEmailRequest> {
  /**
   * Email verification token from the confirmation email.
   *
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<VerifyStudentEmailRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.VerifyStudentEmailRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyStudentEmailRequest {
    return new VerifyStudentEmailRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyStudentEmailRequest {
    return new VerifyStudentEmailRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyStudentEmailRequest {
    return new VerifyStudentEmailRequest().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyStudentEmailRequest | PlainMessage<VerifyStudentEmailRequest> | undefined, b: VerifyStudentEmailRequest | PlainMessage<VerifyStudentEmailRequest> | undefined): boolean {
    return proto3.util.equals(VerifyStudentEmailRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.VerifyStudentEmailResponse
 */
export class VerifyStudentEmailResponse extends Message<VerifyStudentEmailResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  constructor(data?: PartialMessage<VerifyStudentEmailResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.VerifyStudentEmailResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): VerifyStudentEmailResponse {
    return new VerifyStudentEmailResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): VerifyStudentEmailResponse {
    return new VerifyStudentEmailResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): VerifyStudentEmailResponse {
    return new VerifyStudentEmailResponse().fromJsonString(jsonString, options);
  }

  static equals(a: VerifyStudentEmailResponse | PlainMessage<VerifyStudentEmailResponse> | undefined, b: VerifyStudentEmailResponse | PlainMessage<VerifyStudentEmailResponse> | undefined): boolean {
    return proto3.util.equals(VerifyStudentEmailResponse, a, b);
  }
}

/**
 * StudentDocument contains a verification document uploaded by a student.
 *
 * @generated from message mw.customer.StudentDocument
 */
export class StudentDocument extends Message<StudentDocument> {
  /**
   * @generated from field: string filename = 1;
   */
  filename = "";

  /**
   * @generated from field: string mime_type = 2;
   */
  mimeType = "";

  /**
   * @generated from field: bytes data = 3;
   */
  data = new Uint8Array(0);

  /**
   * @generated from field: int64 size_bytes = 4;
   */
  sizeBytes = protoInt64.zero;

  constructor(data?: PartialMessage<StudentDocument>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.StudentDocument";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "filename", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 4, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): StudentDocument {
    return new StudentDocument().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): StudentDocument {
    return new StudentDocument().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): StudentDocument {
    return new StudentDocument().fromJsonString(jsonString, options);
  }

  static equals(a: StudentDocument | PlainMessage<StudentDocument> | undefined, b: StudentDocument | PlainMessage<StudentDocument> | undefined): boolean {
    return proto3.util.equals(StudentDocument, a, b);
  }
}

/**
 * @generated from message mw.customer.UploadStudentDocumentsRequest
 */
export class UploadStudentDocumentsRequest extends Message<UploadStudentDocumentsRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  /**
   * @generated from field: repeated mw.customer.StudentDocument documents = 2;
   */
  documents: StudentDocument[] = [];

  constructor(data?: PartialMessage<UploadStudentDocumentsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.UploadStudentDocumentsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "documents", kind: "message", T: StudentDocument, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadStudentDocumentsRequest {
    return new UploadStudentDocumentsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadStudentDocumentsRequest {
    return new UploadStudentDocumentsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadStudentDocumentsRequest {
    return new UploadStudentDocumentsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UploadStudentDocumentsRequest | PlainMessage<UploadStudentDocumentsRequest> | undefined, b: UploadStudentDocumentsRequest | PlainMessage<UploadStudentDocumentsRequest> | undefined): boolean {
    return proto3.util.equals(UploadStudentDocumentsRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.UploadStudentDocumentsResponse
 */
export class UploadStudentDocumentsResponse extends Message<UploadStudentDocumentsResponse> {
  /**
   * @generated from field: bool success = 1;
   */
  success = false;

  /**
   * @generated from field: string message = 2;
   */
  message = "";

  /**
   * GUIDs of the created document records.
   *
   * @generated from field: repeated string document_ids = 3;
   */
  documentIds: string[] = [];

  constructor(data?: PartialMessage<UploadStudentDocumentsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.UploadStudentDocumentsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "success", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "document_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UploadStudentDocumentsResponse {
    return new UploadStudentDocumentsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UploadStudentDocumentsResponse {
    return new UploadStudentDocumentsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UploadStudentDocumentsResponse {
    return new UploadStudentDocumentsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UploadStudentDocumentsResponse | PlainMessage<UploadStudentDocumentsResponse> | undefined, b: UploadStudentDocumentsResponse | PlainMessage<UploadStudentDocumentsResponse> | undefined): boolean {
    return proto3.util.equals(UploadStudentDocumentsResponse, a, b);
  }
}

/**
 * @generated from message mw.customer.GetStudentStatusRequest
 */
export class GetStudentStatusRequest extends Message<GetStudentStatusRequest> {
  /**
   * @generated from field: string auth_token = 1;
   */
  authToken = "";

  constructor(data?: PartialMessage<GetStudentStatusRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetStudentStatusRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "auth_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStudentStatusRequest {
    return new GetStudentStatusRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStudentStatusRequest {
    return new GetStudentStatusRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStudentStatusRequest {
    return new GetStudentStatusRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetStudentStatusRequest | PlainMessage<GetStudentStatusRequest> | undefined, b: GetStudentStatusRequest | PlainMessage<GetStudentStatusRequest> | undefined): boolean {
    return proto3.util.equals(GetStudentStatusRequest, a, b);
  }
}

/**
 * @generated from message mw.customer.GetStudentStatusResponse
 */
export class GetStudentStatusResponse extends Message<GetStudentStatusResponse> {
  /**
   * @generated from field: bool is_student = 1;
   */
  isStudent = false;

  /**
   * @generated from field: bool is_verified = 2;
   */
  isVerified = false;

  /**
   * Verification validity period (ISO 8601 dates).
   *
   * @generated from field: string verification_start = 3;
   */
  verificationStart = "";

  /**
   * @generated from field: string verification_end = 4;
   */
  verificationEnd = "";

  /**
   * Number of completed PayPal orders.
   *
   * @generated from field: int32 paypal_order_count = 5;
   */
  paypalOrderCount = 0;

  /**
   * Whether the student can use invoice payment
   * (requires prior PayPal order and amount < 1000 EUR).
   *
   * @generated from field: bool can_use_invoice = 6;
   */
  canUseInvoice = false;

  /**
   * Current status: "pending", "approved", "rejected", "expired".
   *
   * @generated from field: string status = 7;
   */
  status = "";

  /**
   * Reason if status is "rejected".
   *
   * @generated from field: string rejection_reason = 8;
   */
  rejectionReason = "";

  constructor(data?: PartialMessage<GetStudentStatusResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "mw.customer.GetStudentStatusResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "is_student", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "is_verified", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "verification_start", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "verification_end", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "paypal_order_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "can_use_invoice", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "rejection_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetStudentStatusResponse {
    return new GetStudentStatusResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetStudentStatusResponse {
    return new GetStudentStatusResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetStudentStatusResponse {
    return new GetStudentStatusResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetStudentStatusResponse | PlainMessage<GetStudentStatusResponse> | undefined, b: GetStudentStatusResponse | PlainMessage<GetStudentStatusResponse> | undefined): boolean {
    return proto3.util.equals(GetStudentStatusResponse, a, b);
  }
}

